// Components
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

export default function SubjectTabs({ tabs, activeTab, changeTab }) {
  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={changeTab}
        aria-label="scrollable auto tabs example"
        className="h-[50px] !text-over-secondary-background !bg-secondary-background border border-[#c2bfbf] p-0"
        TabIndicatorProps={{
          sx: {
            backgroundColor: 'rgb(var(--ternary-background))',
          },
        }}
      >
        {tabs.map(tab => {
          return (
            <Tab
              key={tab}
              sx={{
                color: 'rgb(var(--over-secondary-background)) !important',
              }}
              disableRipple
              label={tab}
              className={`isMOBILEorTablet`}
            />
          )
        })}
      </Tabs>
    </Box>
  )
}
